import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useThemeContext } from "./context/ThemeContext";
// import LoginWithPhone from "./pages/Auth/LoginWithPhone";
// import VerifyOTP from "./pages/Auth/VerifyOTP";
// import Login from "./pages/Auth/Login";
import Authlayout from "./Layouts/AuthLayout";
// import SignUp from "./pages/Auth/SignUp";
// import VerifyPhone from "./pages/Auth/VerifyPhone";
// import VerifyPhoneOTP from "./pages/Auth/VerifyPhoneOTP";
// import AlreadyLoggedIn from "./pages/Auth/AlreadyLoggedIn";
import MainLayout from "./Layouts/MainLayout";
import ChatLayout from "./Layouts/ChatLayout";
import SettingsLayout from "./Layouts/SettingsLayout";
import CallsLayout from "./Layouts/CallsLayout";
// import AddExistingNumber from "./pages/Auth/AddExistingNumber";
// import OTPVerification from "./pages/Auth/OTPVerification";
// import RestoreBackup from "./pages/Auth/RestoreBackup";
// import EmailForBackup from "./pages/Auth/EmailForBackup";
// import Welcome from "./pages/Auth/Welcome";
// import LoginDetails from "./pages/Auth/LoginDetails";
import VerifyEmailOTP from "./pages/Auth/VerifyEmailOTP";
import LoginWithEmail from "./pages/Auth/LoginWithEmail";
import ProfileSetting from "./pages/Auth/ProfileSetting";

import "./styles/main.scss";

const App: React.FC = () => {
  const { theme } = useThemeContext();

  return (
    <>
      <Routes>
        <Route path="/auth" element={<Authlayout />}>
          <Route index element={<Navigate to="login" replace />} />
          <Route path="login" element={<LoginWithEmail />} />
          <Route path="verify-email-otp" element={<VerifyEmailOTP />} />
          <Route path="profile-setting" element={<ProfileSetting />} />

          {/* 
          <Route path="registration" element={<AddExistingNumber />} />
          <Route path="otp-verification" element={<OTPVerification />} />
          <Route path="restore-backup" element={<RestoreBackup />} />
          <Route path="email-backup" element={<EmailForBackup />} />
          <Route path="welcome" element={<Welcome />} />
          <Route path="login-details" element={<LoginDetails />} /> */}

          {/* <Route path="login" element={<Login />} />
          <Route path="login-with-phone" element={<LoginWithPhone />} />
          <Route path="verify-otp" element={<VerifyOTP />} />
          <Route path="verify-phone-otp" element={<VerifyPhoneOTP />} />
          <Route path="sign-up" element={<SignUp />} />
          <Route path="verify-phone" element={<VerifyPhone />} />
          <Route path="already-logged-in" element={<AlreadyLoggedIn />} /> */}
        </Route>

        <Route path="/" element={<MainLayout />}>
          <Route index element={<Navigate to="chat" replace />} />
          <Route path="/calls" element={<CallsLayout />} />
          <Route path="/chat" element={<ChatLayout />} />
          <Route path="/settings" element={<SettingsLayout />} />
        </Route>
      </Routes>

      <ToastContainer
        theme={theme}
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
      />
    </>
  );
};

export default App;
